import {OrderDetails} from './order-details.model';
import {OrderDelivery} from './order-delivery.model';
import {Tyres} from './tyres.model';
import {DeliveryChecksList} from './delivery-checks-list.model';

export abstract class OrdersResponseModel {
	responseStatus = -1;
	abstract value: any;
}

export class OrderResponseDetails extends OrdersResponseModel {
	value: OrderDetails;
}

export class OrderResponseDelivery extends OrdersResponseModel {
	value: OrderDelivery;
}

export class OrderResponseChecks extends OrdersResponseModel {
	value: Map<string, DeliveryChecksList>;
}

export class OrderResponseTyres extends OrdersResponseModel {
	value: Tyres;
}

export enum DeliveryMessagesCode {
	DS_CANT_SIGN_DOSSIER = 4004,
	DS_CANT_COMPLETE_SIGNATURE_PROCESS = 4005,
	FM_CANT_UPLOAD_DOCUMENT = 4500,
	WD_CANT_ATTACH_DS_DOCUMENT_TO_ORDER = 3004,
	WD_CANT_ACCEPT_ORDER = 3005,
	WD_CANT_ACCEPT_ORDER_FOR_SERVICE_UNAVAILABILITY = 3006
}
